	import { cn } from "@/lib/utils"

	interface SpinnerProps {
	size?: "sm" | "md" | "lg"
	className?: string
	}

	export function Spinner({ size = "md", className }: SpinnerProps) {
	const sizeClasses = {
		sm: "h-4 w-4 border-2",
		md: "h-8 w-8 border-2",
		lg: "h-12 w-12 border-3"
	}

	return (
		<div
		className={cn(
			"animate-spin rounded-full border-solid border-current border-r-transparent",
			sizeClasses[size],
			className
		)}
		role="status"
		aria-label="Loading"
		>
		<span className="sr-only">Loading...</span>
		</div>
	)
	}